import React, { Component } from "react";
import { Card, CardContent, Button } from "@material-ui/core";

import firebase from "firebase/app";
class FirebaseSecurityTest extends Component {
    downloadSomething = () => {
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                } else {
                    firebase
                        .database()
                        .ref("/subjects")
                        .on("value", snapshot => {});
                }
            });
        } catch (e) {}
    };
    render() {
        return (
            <Card>
                <CardContent>
                    <Button
                        onClick={() => {
                            this.downloadSomething();
                        }}
                    >
                        Download
                    </Button>
                </CardContent>
            </Card>
        );
    }
}
export default FirebaseSecurityTest;
